import { axiosService } from "@picovico/helpers";
import { getLocalStorageData } from "@picovico/utils";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ReduxState } from "../store";
// import { ReduxState } from "@/store";

type cineSettingInterface = {
  hasData: boolean;
  maxSeatSelectWeb?: number;
  advanceShowDays: number;
};

const initialState: cineSettingInterface = {
  hasData: false,
  advanceShowDays: 5,
};

export const loadCineSettingAsync = createAsyncThunk(
  "cine_setting/load",
  async (params, thunkAPI) => {
    const store = thunkAPI.getState() as ReduxState;
    const cineSetting = store.cineSetting;
    if (cineSetting.hasData) return cineSetting;
    try {
      const { data } = await axiosService({
        name: "cine_setting",
        method: "get",
        idx: getLocalStorageData("cinema_hall"),
      });

      const cineSettingData = data?.data;
      return {
        maxSeatSelectWeb: cineSettingData?.max_seat_select_web,
        advanceShowDays: cineSettingData?.advance_show_days,
      };
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
);

export const cineSettingSlice = createSlice({
  name: "cineSetting",
  initialState,
  reducers: {
    updateCineSetting(state, action) {
      return {
        ...action.payload,
        configSlice: true,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadCineSettingAsync.fulfilled, (state, action) => {
        return {
          ...state,
          ...action.payload,
          hasData: true,
        };
      })
      .addCase(loadCineSettingAsync.rejected, (state) => {
        return {
          ...state,
          hasData: false,
        };
      });
  },
});
